module.exports = __webpack_public_path__ + "media/images/phone/writer-offering-scenario-development-flow-8bdcaba94f13398d485badec4b089347.png";